var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMailS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.273 3.818A2.733 2.733 0 0 1 22 6.545v10.91a2.733 2.733 0 0 1-2.727 2.727H4.727A2.733 2.733 0 0 1 2 17.455V6.545a2.733 2.733 0 0 1 2.727-2.727zm.908 4.474-7.66 5.362a.91.91 0 0 1-.934.065l-.108-.065-7.661-5.362v9.163c0 .462.355.85.804.902l.105.007h14.546c.498 0 .909-.412.909-.91l-.001-9.162zm-.908-2.656H4.727a.915.915 0 0 0-.812.504L12 11.8l8.085-5.66a.915.915 0 0 0-.812-.504z",
    fill: "#14233C",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMailS);
export default __webpack_public_path__ + "static/media/ic-mail-s.50772a5aa20351e252148a993fc2f90c.svg";
export { ForwardRef as ReactComponent };